module.exports = __webpack_public_path__ + "img/customer-bg.52759a34.jpg";